<template>
    <div
        class="spinner-bars"
        :class="colorClass"
    >
        <div class="spinner-bars__el a"></div>
        <div class="spinner-bars__el b"></div>
        <div class="spinner-bars__el c"></div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default Vue.component('SpinnerBars', {
        props: {
            colorClass: {
                type: String,
                default: ''
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/app/modules/shared/components/SpinnerBars.vue